module.exports = (flex = window.flex) => {

    class Subscribable {
        constructor() {
            this.subscriptions = [];
        }

        subscribe(callback, condition = true) {
            const id = flex.uuid();
            this.subscriptions.push({
                id,
                callback,
                condition
            });
            return id;
        }

        unsubscribe(subscriptionId) {
            let index = this.subscriptions.findIndex(s => s.id === subscriptionId);
            if (index === -1) {
                return false;
            }
            this.subscriptions.splice(index, 1);
            return true;
        }

        //override
        broadcast() {
            this.subscriptions.forEach(subscription => {
                subscription.callback();
            });
        }
    }

    return Subscribable;
};